import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { toDataURL } from 'qrcode';
import { type ReactNode, memo, useEffect, useState } from 'react';
import { Dialog, DialogDescription, DialogTitle } from '~/components/ui/LegacyDialog';

interface QrDialogProps {
  open: boolean;
  title?: string;
  data: string;
  children: ReactNode;
  onClose: () => void;
  portalContainer?: Element;
}

const qrOptions = {
  margin: 2,
  width: 250,
};

export const QrDialog = memo<QrDialogProps>(({ open, title, data, onClose, children, portalContainer }) => {
  const [dataURL, setDataURL] = useState<string>();

  useEffect(() => {
    if (data) {
      toDataURL(data, qrOptions).then(setDataURL).catch(console.error);
    }
  }, [data]);

  return (
    <Dialog
      open={open}
      width={500}
      maxWidth="90%"
      maxHeight="90%"
      showCloseButton
      onClose={onClose}
      portalContainer={portalContainer}
      modal
      contentClassName="flex"
    >
      <VisuallyHidden>
        <DialogTitle>{title ?? 'QR Code'}</DialogTitle>
      </VisuallyHidden>
      <DialogDescription className="w-full flex flex-col items-center p-14 overflow-y-auto text-center" unstyled>
        {children}
        <img src={dataURL} className="p-2" />
      </DialogDescription>
    </Dialog>
  );
});

QrDialog.displayName = 'QrDialog';
